import { useEffect } from "react";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

export function Seo({ title, description, noindex = false }) {
  useEffect(() => {
    document.title = title ? `${title} | KLEDIO` : "KLEDIO – Kaufen. Verkaufen. Weitergeben.";
    if (description) setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    return () => setMeta("name", "robots", "index, follow");
  }, [title, description, noindex]);
  return null;
}
